import { useCallback } from "react";

/**
 * Skip Navigation Component
 * ລິ້ງສຳລັບ keyboard users ແລະ screen readers ເພື່ອຂ້າມໄປເນື້ອຫາຫຼັກ
 * ສະແດງເມື່ອກົດ Tab ແລະ ຊ່ອນເມື່ອບໍ່ໄດ້ focus
 */
export function SkipNavigation() {
  const handleSkipToMain = useCallback((e: React.MouseEvent | React.KeyboardEvent) => {
    e.preventDefault();
    const mainContent = document.getElementById("main-content");
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const handleSkipToNav = useCallback((e: React.MouseEvent | React.KeyboardEvent) => {
    e.preventDefault();
    const nav = document.getElementById("main-navigation");
    if (nav) {
      nav.focus();
      nav.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <div className="skip-navigation">
      <a
        href="#main-content"
        onClick={handleSkipToMain}
        onKeyDown={(e) => e.key === "Enter" && handleSkipToMain(e)}
        className="skip-link"
        tabIndex={0}
      >
        ຂ້າມໄປເນື້ອຫາຫຼັກ
      </a>
      <a
        href="#main-navigation"
        onClick={handleSkipToNav}
        onKeyDown={(e) => e.key === "Enter" && handleSkipToNav(e)}
        className="skip-link"
        tabIndex={0}
      >
        ຂ້າມໄປເມນູຫຼັກ
      </a>
    </div>
  );
}

export default SkipNavigation;
